import { Box } from '@mui/material';
import { FC } from 'react';
import { AccountInformationForm } from '@/components/content/Account/parts/InformationForm';
import { usePersonInfo } from '@/data/Content/PersonInfo';
import { AccountChangePasswordForm } from '@/components/content/Account/parts/ChangePasswordForm';
import { AccountPersonalFrameSX } from '@/components/content/Account/styles/accountPersonal';
import { PersonalFormSkeleton } from '@/components/content/Account/parts/Skeletons/PersonalFormSkeleton';

export const AccountPersonal: FC = () => {
	const personInfo = usePersonInfo();

	if (!personInfo.personInfo) {
		return <PersonalFormSkeleton />;
	}

	return (
		<Box sx={AccountPersonalFrameSX}>
			<AccountInformationForm
				personInfo={personInfo.personInfo}
				onSubmit={personInfo.savePersonInfo}
				isLoading={personInfo.open}
			/>
			<AccountChangePasswordForm onSubmit={personInfo.updatePassword} isLoading={personInfo.open} />
		</Box>
	);
};
